/**
 * A labelled single `Select` of the dialogs, with its placeholder and the
 * error shown under it once submitted.
 */
import type { ReactNode } from 'react';
import { Select } from './Select';
import type { SelectOption } from './select-options';

export interface SelectFieldProps {
  id: string;
  name: string;
  label: ReactNode;
  placeholder: string;
  options: readonly SelectOption[];
  value: string;
  onChange: (value: string) => void;
  /** Extra class of the field wrapper (`invalid` while the value is wrong). */
  fieldClassName?: string | undefined;
  className?: string | undefined;
  /** Error message; hidden until `showError`. */
  error?: string | undefined;
  showError?: boolean | undefined;
  testId?: string | undefined;
}

export function SelectField({
  id,
  name,
  label,
  placeholder,
  options,
  value,
  onChange,
  fieldClassName = '',
  className = 'mb-2',
  error,
  showError = false,
  testId,
}: Readonly<SelectFieldProps>) {
  return (
    <div className={className}>
      <label className="field-label" htmlFor={id}>
        {label}
      </label>
      <div className={`field field-selector ${fieldClassName}`}>
        <Select
          id={id}
          name={name}
          placeholder={placeholder}
          options={options}
          value={value}
          onChange={onChange}
          testId={testId}
        />
      </div>
      {error !== undefined && <small hidden={!showError}>{error}</small>}
    </div>
  );
}
